import * as actions from '../../actions/dobovoActions'
import { urlParams } from '../../utils/mainUtils'
import { handleErrorWithMessage, handleResponse, securedFetch } from '../apiUtils'
import * as urls from '../urls'

/**
 * @param {Object} params - List of path params
 * @param {number[]} params.organizationIds - Organization Ids
 */
export const dobovoPushYearPrices = params => (dispatch, getState) => {
    const { auth } = getState()

    dispatch(actions.dobovo_pushYearPricesRequest())

    securedFetch(urlParams(urls.dobovoPushYearPrices, params), auth, { method: 'POST' })
        .then(handleResponse)
        .then(() => dispatch(actions.dobovo_pushYearPricesSuccess()))
        .catch(handleErrorWithMessage(dispatch, actions.dobovo_pushYearPricesFailure))
}

/**
 * @param {Object} params - List of path params
 * @param {number[]} params.organizationIds - Organization Ids
 */
export const dobovoPushYearRestrictions = params => (dispatch, getState) => {
    const { auth } = getState()

    dispatch(actions.dobovo_pushYearRestrictionsRequest())

    securedFetch(urlParams(urls.dobovoPushYearRestrictions, params), auth, { method: 'POST' })
        .then(handleResponse)
        .then(() => dispatch(actions.dobovo_pushYearRestrictionsSuccess()))
        .catch(handleErrorWithMessage(dispatch, actions.dobovo_pushYearRestrictionsFailure))
}

/**
 * @param {Object} params - List of path params
 * @param {number} params.organizationId - Organization Id
 */
export const dobovoPushYearAvailability = params => (dispatch, getState) => {
    const { auth } = getState()

    dispatch(actions.dobovo_pushYearAvailabilityRequest())

    securedFetch(urlParams(urls.dobovoPushYearAvailability, params), auth, { method: 'POST' })
        .then(handleResponse)
        .then(() => dispatch(actions.dobovo_pushYearAvailabilitySuccess()))
        .catch(handleErrorWithMessage(dispatch, actions.dobovo_pushYearAvailabilityFailure))
}

/**
 * @param {Object} params - List of path params
 * @param {number} params.organizationId - Organization Id
 */
export const dobovoSynchronizeProperty = params => (dispatch, getState) => {
    const { auth } = getState()

    dispatch(actions.dobovo_synchronizePropertyRequest())

    securedFetch(urlParams(urls.dobovoSynchronizeProperty, params), auth, { method: 'POST' })
        .then(handleResponse)
        .then(() => dispatch(actions.dobovo_synchronizePropertySuccess()))
        .catch(handleErrorWithMessage(dispatch, actions.dobovo_synchronizePropertyFailure))
}



// WEBPACK FOOTER //
// ./src/api/dobovoApi/dobovoSync.js